<script>
import { BAlert, BCol, BRow } from 'bootstrap-vue'
import Overlay from '@core/components/common/Overlay.vue'
import RegulationQuestions from '@/views/product/components/product-card/RegulationQuestions.vue'

export default {
    components: {
        BAlert,
        BCol,
        BRow,
        Overlay,
        RegulationQuestions,
    },
    props: {
        section: {
            type: Object,
            required: true,
        },
        groups: {
            type: Array,
            default() {
                return []
            },
        },
        legislations: {
            type: Array,
            default() {
                return []
            },
        },
        loading: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        answers() {
            return Array.isArray(this.section.answers) ? this.section.answers : []
        },
        answeredQuestionIds() {
            return this.answers.reduce((questionIds, answer) => {
                if (!answer || answer.questionId === undefined || answer.questionId === null) {
                    return questionIds
                }

                return {
                    ...questionIds,
                    [String(answer.questionId)]: true,
                }
            }, {})
        },
        filteredGroups() {
            return this.groups
                .map(group => ({
                    ...group,
                    questions: (group.questions || []).filter(question => (
                        question && this.answeredQuestionIds[String(question.id)]
                    )),
                }))
                .filter(group => group.questions.length > 0)
        },
        showEmptyState() {
            return !this.loading && this.filteredGroups.length === 0
        },
    },
}
</script>

<template>
    <div>
        <b-row>
            <div class="mb-1 mt-1 pl-1">
                <h3>{{ $t('Component(ProductCardTabs):regulation-questions-label') }}</h3>
            </div>
        </b-row>
        <b-row>
            <b-col>
                <Overlay :show="loading">
                    <RegulationQuestions
                        v-if="filteredGroups.length > 0"
                        :groups="filteredGroups"
                        :legislations="legislations"
                        :answers="answers"
                        read-only
                    />
                    <b-alert
                        v-if="showEmptyState"
                        variant="secondary"
                        show
                    >
                        <div class="alert-body">
                            <span>No regulation question answers were provided.</span>
                        </div>
                    </b-alert>
                </Overlay>
            </b-col>
        </b-row>
    </div>
</template>
